import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { getDenormalizedDataEntityById } from '../../redux/entities';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';

const getNormalizedDeviation = createSelector(
  state => state,
  (_, deviationId: number) => deviationId,
  (state, deviationId) =>
    getDenormalizedDataEntityById(state, deviationSchema, deviationId)
);

export function useNormalizedDeviation(deviationId: number) {
  return useSelector(state => getNormalizedDeviation(state, deviationId));
}
